import { render, staticRenderFns } from "./CpoIntentionApprovalControl.vue?vue&type=template&id=4a64d1b9&scoped=true"
import script from "./CpoIntentionApprovalControl.vue?vue&type=script&lang=js"
export * from "./CpoIntentionApprovalControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64d1b9",
  null
  
)

export default component.exports